import { create } from "zustand"
import { persist } from "zustand/middleware"

export const MAX_HISTORY_ENTRIES = 20
export const HISTORY_RETENTION_MS = 3 * 24 * 60 * 60 * 1000

export type PhotoHistoryEntry = {
  jobId: string
  createdAt: string
  transactionId?: string
  childFrameId?: string
  frameName?: string
}

type PhotoHistoryStore = {
  entries: PhotoHistoryEntry[]
  addEntry: (entry: PhotoHistoryEntry) => void
  reset: () => void
}

export function pruneEntries(
  entries: PhotoHistoryEntry[],
  now = Date.now(),
): PhotoHistoryEntry[] {
  return entries.filter(
    (entry) => now - Date.parse(entry.createdAt) <= HISTORY_RETENTION_MS,
  )
}

function capEntries(entries: PhotoHistoryEntry[]): PhotoHistoryEntry[] {
  return entries.slice(0, MAX_HISTORY_ENTRIES)
}

const usePhotoHistoryStore = create<PhotoHistoryStore>()(
  persist(
    (set) => ({
      entries: [],
      addEntry: (entry) =>
        set((state) => ({
          entries: capEntries([
            entry,
            ...pruneEntries(
              state.entries.filter((existing) => existing.jobId !== entry.jobId),
            ),
          ]),
        })),
      reset: () => set({ entries: [] }),
    }),
    { name: "photo-history-store" },
  ),
)

export { usePhotoHistoryStore }
